// src/lib/api/auth/authApi.ts
import axiosInstance from '@/lib/api/core/axiosInstance';

export const login = async (email: string, password: string) => {
  // Turbopack import 이슈 대응: 인스턴스가 함수가 아닐 경우를 방지
  const api = (axiosInstance as any).default || axiosInstance;

  try {
    const res = await api.post("/api/auth/login", {
      email,
      password,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
